/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ListMyGroupsResponse = zod.object({
  groups: zod.array(
    zod.object({
      description: zod.string().nullable(),
      groupActorUuid: zod.uuid(),
      id: zod.string(),
      name: zod.string(),
      parentGroupActorUuid: zod
        .uuid()
        .nullable()
        .describe(
          'The parent, when this is a sub-group whose parent the caller can see; otherwise null.',
        ),
      permissions: zod
        .array(zod.string())
        .describe(
          "The caller's permission slugs in the group, including what its parent's Admin role brings.",
        ),
      subGroupCount: zod
        .int()
        .describe('How many of its sub-groups the caller can see; 0 for a sub-group.'),
      visibility: zod.enum(['PUBLIC', 'PRIVATE', 'SECRET']),
    }),
  ),
  nextCursor: zod.string().nullable(),
  partial: zod
    .boolean()
    .optional()
    .describe(
      "Present only when the caller belongs to groups homed in another region, whose homes were asked too. True when one of those regions didn't answer: its groups are then listed as this region last recorded them.",
    ),
  totalCount: zod.int(),
  unavailableRegions: zod
    .array(zod.string())
    .optional()
    .describe("Present with `partial`: the regions that didn't answer, e.g. ['us']."),
});

export type ListMyGroupsResponse = zod.input<typeof ListMyGroupsResponse>;
export type ListMyGroupsResponseOutput = zod.output<typeof ListMyGroupsResponse>;
